import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "react-bootstrap-table-next";
import Button from "components/CustomButtons/Button.jsx";
import Modal from "react-bootstrap/Modal";

import { getOem, deleteOem } from "../../../rest/oem"

class ListOem extends React.Component {

  state = {
    oemData: [],
    showModal: false
  };

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    await this.fetchOems();
  }

  fetchOems = async() => {
    try{
      let res = await getOem();
      this.setState({
        oemData: res.data
      })
    } catch (e){
      console.log(e);
    }
  }

  nameFormatter = (cell, row) => {
    return (
      <span className="hyperlink" onClick={() => { this.props.history.push(`/admin/oems/${row.id}`)}}>{cell}</span>
    );
  }

  deleteFormatter = (cell, row) => {
    return (
        <div className="text-center">
            <span className="fa fa-trash text-center" onClick={() => { this.openModal(cell)}}></span>
        </div>    
    );
  }

  navToDetails = () => {
    this.props.history.push(`/admin/oems/0`);
  }

  openModal = (id) => {
    this.setState({
        showModal: true,
        oemId: id
      });
  }

  hideModal = () => {
      this.setState({
          showModal: false
      });
  }

  deleteOem = async() => {
    try {
      await deleteOem(this.state.oemId);
      this.setState({
          showModal: false,
          oemId: ""
      }, async () => {
          alert("Oem Deleted Successfully");
          await this.fetchOems();
      });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const tableColDef = [{
      dataField: 'name',
      text: 'Name',
      formatter: this.nameFormatter
    }, {
      dataField: 'address',
      text: 'Address',
    }, {
      dataField: 'primaryContact',
      text: 'Primary Contact',
    }, {
      dataField: 'primaryEmail',
      text: 'Email',
    }, {
      dataField: 'primaryPhone',
      text: 'Phone',
    }, {
      dataField: 'id',
      text: '',
      formatter: this.deleteFormatter
    }];

    return (
      <div>
        <Card>
          <CardHeader color="primary">
            <h4><b>Oems</b></h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className="float_rght"
                    onClick={this.navToDetails}
                >
                  <b>Add Oem</b>
                </Button>
              </GridItem>   
              <GridItem sm={12} md={12}>
                <Table keyField="name"
                  data={this.state.oemData}
                  columns={tableColDef}
                  noDataIndication="No Oems Available"/>  
              </GridItem>
            </GridContainer>  
          </CardBody>  
        </Card>

        <Modal
          show={this.state.showModal}
          onHide={this.hideModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                  Delete Oem!!!
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>    
              <span> Are you sure, you want to delete the oem.</span>
          </Modal.Body>
          <Modal.Footer>
              <Button
                  type="button"
                  variant="contained"
                  className="float_rght"
                  onClick={this.hideModal}
              >
                  Cancel
              </Button>
              <Button
                  type="button"
                  variant="contained"
                  className="float_rght"
                  color="primary"
                  onClick={this.deleteOem}
              >
                  Delete
              </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ListOem;